import { Prospective } from 'components/home/prospective';
const ProspectiveContainer = Prospective;
export { ProspectiveContainer };
